import { Configuration } from "./Configuration";

export interface ConfigurationExportMetadata {
    version: number;
    exportedAt: string;
    exportedBy: string;
    sourceInstance: string;
    description?: string;
}

export interface ConfigurationExport {
    metadata: ConfigurationExportMetadata;
    configuration: Configuration;
}

export interface ConfigurationImportRequest {
    exportData: ConfigurationExport;
    groupsToImport?: string[];
    previewOnly: boolean;
    fieldGroups?: Record<string, string[]>;
}

export interface ConfigurationChange {
    group: string;
    fieldName: string;
    currentValue?: string;
    newValue?: string;
    type: ChangeType;
}

export enum ChangeType {
    Added = 0,
    Modified = 1,
    Removed = 2,
    Unchanged = 3
}

export interface ConfigurationImportPreview {
    changes: ConfigurationChange[];
    warnings: string[];
    errors: string[];
    changeCountsByGroup: Record<string, number>;
    canApply: boolean;
}

export function formatChangeType(type: ChangeType): string {
    switch (type) {
        case ChangeType.Added:
            return "Added";
        case ChangeType.Modified:
            return "Modified";
        case ChangeType.Removed:
            return "Removed";
        case ChangeType.Unchanged:
            return "Unchanged";
        default:
            return "Unknown";
    }
}

export function getChangeTypeBadgeVariant(type: ChangeType): string {
    switch (type) {
        case ChangeType.Added:
            return "success";
        case ChangeType.Modified:
            return "warning";
        case ChangeType.Removed:
            return "danger";
        case ChangeType.Unchanged:
            return "secondary";
        default:
            return "secondary";
    }
}
